import * as React from 'react'
import { FC } from 'react'
import { GithubOutlined, GoogleOutlined } from '@ant-design/icons'

const Providers = {
  github: { icon: <GithubOutlined /> },
  google: { icon: <GoogleOutlined /> },
}

export const ProviderIcon: FC<{ provider: string; style?: { [key: string]: any } }> = ({ provider, style }) => {
  if (Providers[provider] && Providers[provider].icon)
    return (
      <div style={style} title={provider}>
        {Providers[provider].icon}
      </div>
    )
  return null
}
